import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import LanguageSelector from "./LanguageSelector";
import logo from "../assets/logo.png";
import "./Header.css";

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { t } = useTranslation();
  const location = useLocation();
  const isHome = location.pathname === "/";

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setIsMenuOpen(false);
  }, [location.pathname]);

  const sectionLink = (hash) => (isHome ? hash : `/${hash}`);

  return (
    <header className={`header ${isScrolled || !isHome ? "scrolled" : ""}`}>
      <Link to="/" className="logo">
        <img src={logo} alt="Convertrex Logo" />
      </Link>

      <div className={`menu-icon ${isMenuOpen ? "active" : ""}`} onClick={() => setIsMenuOpen(!isMenuOpen)}>
        <span></span>
        <span></span>
        <span></span>
      </div>

      <nav className={`nav-links ${isMenuOpen ? "active" : ""}`}>
        <Link to="/">{t("nav.home")}</Link>
        <a href={sectionLink("#solutions")}>{t("nav.services")}</a>
        <a href={sectionLink("#about")}>{t("nav.about")}</a>
        <Link to="/planos">{t("nav.plans")}</Link>
        <a href={sectionLink("#contact")}>{t("nav.contact")}</a>
        <Link to="/planos" className="nav-cta">
          Começar agora
        </Link>
        <div className="language-selector">
          <LanguageSelector />
        </div>
      </nav>
    </header>
  );
};

export default Header;
